import Input, { InputTypes } from './Input';
import InputWithButtonPopoverList from './InputWithButtonPopoverList';
import InputWithRenderer from './InputWithRenderer';
import popOverFactory from 'common/components/core/popover/popOverFactory';
import { enhancedFieldFactory } from 'common/components/core/form/EnhancedFieldFactory';
import InputIconView from 'common/components/core/input/InputIconView';

const InputWithPopOver = popOverFactory({
    Component: Input
});

const EnhancedInput = enhancedFieldFactory({
    FieldComponent: InputWithPopOver
});

export {
    Input,
    InputTypes,
    InputWithRenderer,
    InputWithPopOver,
    InputWithButtonPopoverList,
    EnhancedInput,
    InputIconView
};

export default Input;
